import React from 'react'
import UserForgot from '../../components/UserForgot/UserForgot'

function UserForgotPage() {
  return (
    <UserForgot />
  )
}

export default UserForgotPage